const organisations = {
	title: "Organisations",
	title_s: "Organisation",
	new_organisation: "New Organisation",
	edit_organisation: "Edit Organisation: {name}",
	view_organisation: "View Organisation: {name}",
	list_title: "List of Organisations",
	list_subtitle: "Manage organisations",
	create_title: "Create New Organisation",
	update_title: "Update Organisation",
	details_title: "Organisation Details",
	visiting_address_title: "Visiting Address",
	invoice_address_title: "Invoice Address",
	invoice_title: "Invoice Details",
	id: "ID",
	name: "Name",
	email: "Email",
	vat: "VAT",
	code: "Organisation Code",
	phone: "Phone",
	owner: "System Owner",
	po_number: "PO",
	invoice_ref: "Customer Ref.",
	email_invoice: "Invoice Email",
	same_as_visiting: "Same as Visiting Address",
	certification_authority: "Certification Authority for XL3",
	certification_authority_short: "Cert. Auth. for XL3",
	certification_authority_123service: "Certification Authority for XL3",
	certification_authority_123service_short: "Cert. Auth. for XL3",
	certification_company_id: "Certification Company",
	member_organisation: "Is Member Organisation",
	member_organisation_short: "Mem.org.",
	certification_agencies: "Certification Agencies",
	certification_agencies_by: "Certified By",
	course_type_groups: "Allowed Course Type Groups",
	course_types: "Allowed Course Types",
	customergroups: "Customer Groups",
	member_of: "Member of",
	course_types_and_group: "Course types and groups",
	visiting_street: "Street",
	visiting_city: "City",
	visiting_state: "State",
	visiting_zip: "Zip",
	visiting_country: "Country",
	invoice_street: "Street",
	invoice_city: "City",
	invoice_state: "State",
	invoice_zip: "Zip",
	invoice_country: "Country",
	logo: "Logo",
	member_logo: "Member Logo",
	upload_image: "Upload/Update Logo",
	select_image: "Select logo to upload",
	upload_ml_image: "Upload/Update Member Logo",
	select_ml_image: "Select member logo to upload",
	update_tenants: "Would you like to update tenant(s)?",
	org_active_users: "Organisation Active Users",
	no_of_active_users: "No. of Active Users",
	no_of_tenants: "No. of Tenants",
	org_does_not_exist: "No organisation found",
	has_active_tenants: "Organisation has an active tenant(s). Failed to delete.",
	vat_does_not_exist: "VAT does not exist",
	agreement_active_from: "Agreement active from",
	agreement_cancelled_from: "Agreement cancelled from",
	agreement_responsible: "Agreement responsible",
	internal_note: "Internal note",
	certification_id: "Certification / Approval ID",
};
export default organisations;